import axios from "../api/api"
import { useEffect, useState } from "react";
import { Modal, Table } from "react-bootstrap";

const GETDATABYID = "/api/aarti"

const AartiModel = ({ show, setShow, id, setId }) => {
    const [content, Setcontent] = useState([])

    useEffect(() => {
        const getdatabyid = async () => {
            if (show === true) {
                const response = await axios.get(`${GETDATABYID}/${id}`)
                const data = response.data
              Setcontent(data)

            }else {
                Setcontent([])
            }
        }
        getdatabyid()
    }, [id])

    // Handle hide
    const handleHide = () => {
        setId(null);
        setShow(false);
    }



    return (
        <Modal show={show} onHide={handleHide} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Aarti Details -{content?.aarti?.hindititle} </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {
                    content?.aarti?.status === "published" ? <strong className="text-capitalize text-green">{content?.aarti?.status}  </strong> : <strong className="text-capitalize text-red">{content?.aarti?.status} on {content?.aarti?.scheduledate} </strong>  
                }
                <Table bordered striped hover>
                    <tbody>
                        <td>{content?.aarti?.content}</td>
                    </tbody>
                </Table>
            </Modal.Body>
        </Modal>
    )
}

export default AartiModel;